module.exports = __webpack_public_path__ + "img/3_1.000d6767.png";